(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-specs-badge"] && !Shopify.designMode) return;
  try {
    if (!window.__productCardSpecsSyncBound) {
    window.__productCardSpecsSyncBound = true;

    // 'toggle' events on <details> don't bubble in all browsers, but the
    // capturing phase still fires for every dispatch regardless of bubbling,
    // so listening on document with capture:true reliably catches every
    // instance, including ones added later (e.g. by infinite scroll).
    document.addEventListener(
      'toggle',
      function (event) {
        var target = event.target;
        if (!target.classList || !target.classList.contains('js-product-card-specs')) {
          return;
        }

        var shouldOpen = target.open;

        document.querySelectorAll('.js-product-card-specs').forEach(function (el) {
          if (el !== target && el.open !== shouldOpen) {
            el.open = shouldOpen;
          }
        });
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
